export type Question = {
  id: string;
  text: string;
  options: string[];
  correctIndex: number;
  explanation: string;
};

export type ModuleContent = {
  id: string;
  title: string;
  definition: string; // "What it is"
  entryVectors: string; // "How it typically gets in"
  objectives: string; // "What it tries to achieve"
  warningSigns: string[]; // "Early warning signs"
  prevention: string[]; // "Prevent" controls (Top 5)
  detection: string[]; // "Detect" controls (Top 3)
  response: string[]; // "Respond" steps (Top 5)
  myth: {
    myth: string;
    reality: string;
  };
  quiz: Question[];
  classMode?: {
    duration: string;
    discussion: string[];
  };
};

export type CaseStudy = {
  id: string;
  title: string;
  scenario: string;
  options: {
    text: string;
    feedback: string;
    isSafe: boolean;
  }[];
};

export type UserProgress = {
  completedModules: string[];
  moduleScores: Record<string, number>; // id -> score (0-100)
  assessmentScore: number | null;
  caseStudiesCompleted: string[];
  dyslexiaMode: boolean;
  classModeEnabled: boolean; // New toggle for teachers
};

export enum View {
  HOME = 'HOME',
  LEARN = 'LEARN',
  MODULE_DETAIL = 'MODULE_DETAIL',
  COMPARE = 'COMPARE',
  DEFEND = 'DEFEND',
  CASES = 'CASES',
  ASSESSMENT = 'ASSESSMENT',
  TEACHER = 'TEACHER',
  DASHBOARD = 'DASHBOARD',
  SANDBOX = 'SANDBOX',
}
